import { createSelector } from 'reselect';
import { TimelycodeStore } from '../../../shared/types';

const selectCarers = (state: TimelycodeStore) => state.careers;

export const getInTOuchData = () => createSelector(selectCarers, state => state.inTouch || []);
export const getOffer = () => createSelector(selectCarers, state => state.offer);
export const getVacancies = () => createSelector(selectCarers, state => state.vacancies);
export const getMessages = () => createSelector(selectCarers, state => state.messages);
